import { Progress, Space } from 'antd';
import { Card } from 'antd';
import { Col } from 'antd';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { getAgencyLogoURL } from '../../utils/S3Helper';
import fallbackImage from '../../assets/img/agency-no-logo.jpg';
import { mdlDashboardAgency } from '../../models/ui-models/DashboardAgency';
const { Text } = Typography;

const AgencyCard = (
    {
        agency,
        index
    }: {
        agency: mdlDashboardAgency;
        index: number;
    }
) => {
    const { t } = useTranslation();

    return (
        <Col xs={24} sm={12} md={8} lg={6} key={index}>
            <Card
                hoverable
                bodyStyle={{ padding: '20px' }}
                bordered={false}
                style={{ borderRadius: '16px', background: '#fff' }}
            >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Space direction="vertical" size={2}>
                            <Text strong style={{ fontSize: '16px', color: '#262626' }}>
                                {agency.name}
                            </Text>
                            <Text type="secondary" style={{ fontSize: '13px' }}>
                                {agency.reservations.toLocaleString()} {t('dashboard.reservations')}
                            </Text>
                        </Space>
                        {agency.logo && (
                            <div style={{
                                padding: '8px',
                                background: '#fafafa',
                                borderRadius: '8px'
                            }}>
                                <img
                                    src={getAgencyLogoURL(agency.logo)}
                                    alt={agency.name}
                                    style={{ width: '64px', height: '64px', objectFit: 'contain' }}
                                    onError={(e) => {
                                        e.currentTarget.src = fallbackImage;
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '6px'
                            }}>
                                <Text type="secondary" style={{ fontSize: '13px' }}>
                                    {`${t('dashboard.new')} ${t('dashboard.reservations')}`}
                                </Text>
                                <Text style={{ color: '#52c41a', fontSize: '13px' }}>
                                    {agency.details.new.toLocaleString()}
                                </Text>
                            </div>
                            <Progress
                                percent={Math.round((agency.details.new / agency.reservations) * 100)}
                                strokeColor="#52c41a"
                                showInfo={false}
                                size="small"
                                strokeWidth={4}
                            />
                        </div>
                        <div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '6px'
                            }}>
                                <Text type="secondary" style={{ fontSize: '13px' }}>
                                    {`${t('dashboard.changed')} ${t('dashboard.reservations')}`}
                                </Text>
                                <Text style={{ color: '#faad14', fontSize: '13px' }}>
                                    {agency.details.changed.toLocaleString()}
                                </Text>
                            </div>
                            <Progress
                                percent={Math.round((agency.details.changed / agency.reservations) * 100)}
                                strokeColor="#faad14"
                                showInfo={false}
                                size="small"
                                strokeWidth={4}
                            />
                        </div>
                        <div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '6px'
                            }}>
                                <Text type="secondary" style={{ fontSize: '13px' }}>
                                    {`${t('dashboard.cancelled')} ${t('dashboard.reservations')}`}
                                </Text>
                                <Text style={{ color: '#ff4d4f', fontSize: '13px' }}>
                                    {agency.details.cancelled.toLocaleString()}
                                </Text>
                            </div>
                            <Progress
                                percent={Math.round((agency.details.cancelled / agency.reservations) * 100)}
                                strokeColor="#ff4d4f"
                                showInfo={false}
                                size="small"
                                strokeWidth={4}
                            />
                        </div>
                    </Space>
                </Space>
            </Card>
        </Col>
    )
}

export default AgencyCard